module.exports = __webpack_public_path__ + "img/9507652.jpg";